"use strict";function enable$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.enable$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="ui.webViewBounce.enable";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.enable$=enable$,exports.default=enable$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/ui/webViewBounce/enable.js
// module id = 1102
// module chunks = 106